<!--<div class="row mt-4 mb-2 justify-content-end">-->
<!--  <div class="col-6 col-md-8 order-lg-3 col-lg-2">-->
<!--    <p class="teaching__digits">-->
<!--      1-->
<!--      / 1-->
<!--    </p>-->
<!--    <p class="teaching__legend">Новости</p>-->
<!--    <p class="teaching__legend_mute">Просмотров / Количество</p>-->
<!--  </div>-->
<!--  <div class="col-6 col-md-8 order-lg-3 col-lg-2">-->
<!--    <p class="teaching__digits">-->
<!--      1-->
<!--      / 1-->
<!--    </p>-->
<!--    <p class="teaching__legend">Акции</p>-->
<!--    <p class="teaching__legend_mute">Просмотров / Количество</p>-->
<!--  </div>-->
<!--</div>-->
<ul class="navigation__tabs">
  <li class="navigation__tab">
    <a class="navigation__tab__link" routerLink="/news/list" routerLinkActive="navigation__tab__link_active">
      Новости
      @if (newsTotal) {
        <span class="text-muted"> {{ newsTotal }} шт. </span>
      }
      @if (newsViewsTotal) {
        <i class="fa fa-fw fa-eye fa-align-center eye-icon-muted"></i>
        <span class="text-muted"> {{ newsViewsTotal }}</span>
      }
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
  <li class="navigation__tab">
    <a class="navigation__tab__link" routerLink="/news/actions" routerLinkActive="navigation__tab__link_active">
      Баннеры
      @if (bannerTotal) {
        <span class="text-muted"> {{ bannerTotal }} шт. </span>
      }
      @if (bannerViewsTotal) {
        <i class="fa fa-fw fa-eye fa-align-center eye-icon-muted"></i>
        <span class="text-muted"> {{ bannerViewsTotal }} </span>
      }
      <span class="navigation__tab__link_active__slide"></span>
    </a>
  </li>
</ul>
<router-outlet></router-outlet>
